import { AccessoryType } from './accessory-type.enum';
import { ChargerPhaseType } from './charger-phase-type.enum';

export class AccessoryProperties {
	chargerPhaseType: ChargerPhaseType;
	numberOfAccesoryPerChargingPoint: number;
	accessoryType: AccessoryType;
	productId: string;
}
